<template>
    <div id="app">
        <section class="team service">
            <div class="team-decor">
                <div class="team-circle1">
                    <img :src="require('../assets/images/team1.png')" alt="" />
                </div>
                <div class="team-circle2">
                    <img :src="require('../assets/images/team3.png')" alt="" />
                </div>
                <div class="team-circle3">
                    <img :src="require('../assets/images/team.png')" alt="" />
                </div>
            </div>
            <div class="container">
                <div class="row ">
                    <div class="col-sm-12">
                        <h2 class="title">our <span>services</span></h2>
                    </div>
                    <div class="col-sm-12">
                        <div>
                            <carousel
                                :className="'team-carousel'"
                                :margin="30"
                                :items="3"
                                :nav="false"
                                :dots="true"
                                :dotsEach="false"
                                :autoplay="true"
                                :responsive="{
                                    0: { items: 1, margin: 5 },
                                    600: { items: 1, margin: 5 },
                                    768: { items: 2 },
                                    992: { items: 3 },
                                    1000: { items: 3 },
                                }"
                            >
                                <div class="team-item">
                                    <div class="service-block">
                                        <div class="team-box service-box">
                                            <div class="">
                                                <img :src="require('../assets/images/custom.png')" alt="" class="service-image" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Custom Programming</h3>
                                                <h6>
                                                    Certified Custom Programming For all AV needs
                                                </h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="service-social">
                                                    <li>
                                                        <i class="" aria-hidden="true">#Crestron</i>
                                                    </li>
                                                    <li>
                                                        <i class="" aria-hidden="true">#AMX</i>
                                                    </li>
                                                    <li>
                                                        <i class="" aria-hidden="true">#Cloud</i>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="team-item">
                                    <div class="service-block">
                                        <div class="team-box service-box">
                                            <div class="">
                                                <img :src="require('../assets/images/support.png')" alt="" class="service-image" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Support</h3>
                                                <h6>
                                                    Expert AV Support for all system diagnostics
                                                </h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="service-social">
                                                    <li>
                                                        <i class="" aria-hidden="true">#Service</i>
                                                    </li>
                                                    <li>
                                                        <i class="" aria-hidden="true">#Diagnose</i>
                                                    </li>
                                                    <li>
                                                        <i class="" aria-hidden="true">#RMS</i>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="team-item">
                                    <div class="service-block">
                                        <div class="team-box service-box">
                                            <div class="">
                                                <img :src="require('../assets/images/audio.png')" alt="" class="service-image" />
                                            </div>
                                            <div class="team-text">
                                                <h3>Audio</h3>
                                                <h6>
                                                    Proffessional Audio Configuration and Commissioning
                                                </h6>
                                            </div>
                                            <div class="overlay">
                                                <ul class="service-social">
                                                    <li>
                                                        <i class="" aria-hidden="true">#Crestron</i>
                                                    </li>
                                                    <li>
                                                        <i class="" aria-hidden="true">#Biamp</i>
                                                    </li>
                                                    <li>
                                                        <i class="" aria-hidden="true">#QSC</i>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </carousel>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "Services"
}
</script>

<style>
.service-block .service-social li a {
    color: #444444;
    width: 126px;
    font-size: 14px;
    color: #59f7df;
    transition: all 0.3s ease;
    padding: 8px;
    text-align: center;
}
.service-block .service-social li a i {
    width: 126px;
    font-size: 14px;
    color: #444444;
}

.service-image {
    height: 125px;
    width: 125px !important;
    margin: 0 auto;
}

.service-box {
    height: 300px;
}

.service-social {
    position: absolute;
    -webkit-transition: 0.3s ease-in-out;
    transition: 0.3s ease-in-out;
    width: 100%;
    display: flex;
    justify-content: space-around;
    text-align: center;
    padding: 0;
    margin: 0;
}

.service-social > li {
    margin: 0 2px;
    flex-grow: 1;
}

.service {
    background-image: url(../assets/images/services-bg.png) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/services.vue